import React from 'react';
import {__GPYPost} from '../../../env.js'

class GpyComponent extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
      };
  }

  sendGameState(obj){
      console.log("setGameState:",obj);
     __GPYPost('setGameState',obj);
  }

  startTimer(_timerName,_offset,_countdown,id) {
    var obj = {
            timerName: _timerName,
            offset: _offset,
            countdown:_countdown,
            gpyComponentID: id,
    };
    console.log("startTimer()",obj);
     __GPYPost('startTimer',obj);
  }

  setTimerOffset (_timerName,_offset,_countdown,id,callback){
      var obj = {
              timerName: _timerName,
              offset: _offset,
              countdown: _countdown,
              gpyComponentID: id,
      };
      console.log("setTimerOffset()",obj);
      __GPYPost('setTimerOffset',obj,callback);
   }

   stopTimer(_timerName,id) {
      var obj = {
              timerName: _timerName,
              gpyComponentID: id,
      };
      console.log("stopTimer()",obj);
    //  console.log("stopTimer()",new Error().stack);      
      __GPYPost('stopTimer',obj);
   }

   getId(){
     return Math.random().toString(36).substr(2, 9);
   }
}


export default GpyComponent;
